import BaseService from "@/services/base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class SettingService extends BaseService {
  async getGameSettings() {
    return await this.get(`${VUE_APP_API_URL}/api/settings`).then(
      ({ data }) => data
    );
  }

  async getGameAccountSettings() {
    return await this.get(`${VUE_APP_API_URL}/api/account-settings`).then(
      ({ data }) => data
    );
  }
}

export default new SettingService();
